import cx from 'classnames';

import {Icon, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';
import {getCategoryIconName} from '#util/getCategoryIconName';

import {TabProps, TabsProps} from './Tabs.types';

import * as css from './Tabs.css';

const Tab = ({name, onClick, selected}: TabProps) => (
  <button className={css.root({selected})} onClick={onClick}>
    <Icon
      aria-label={name}
      color={selected ? 'grapefruit' : 'dustyGray'}
      name={getCategoryIconName(name)}
    />
    <Text
      aria-hidden
      className={sprinkles({display: ['none', selected ? 'flex' : 'none', 'flex']})}
      color={selected ? 'grapefruit' : 'doveGray'}
      transform="capitalize">
      {name}
    </Text>
  </button>
);

/**
 * The tabs component is used to present a set of tab buttons used primarily for navigation
 * within a given route
 */
export const Tabs = ({className, onClick, tabNames, selected, ...otherProps}: TabsProps) => (
  <div className={cx(sprinkles({flex: 'flex', content: 'center'}), className)} {...otherProps}>
    {tabNames.map((name, index) => (
      <Tab key={name} name={name} onClick={() => onClick(index)} selected={selected === index} />
    ))}
  </div>
);
